"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ImageLinkCardModule = _interopRequireDefault(require("./ImageLinkCard.module.css"));
var _LoadingImage = _interopRequireDefault(require("../LoadingImage/LoadingImage"));
var Arrow = function Arrow(_ref) {
  var fill = _ref.fill;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "42",
    height: "42",
    viewBox: "1327.001 2657.002 51.999 51.998",
    fill: fill,
    "data-testid": "image-link-card-icon"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1352.998 2709a25.81 25.81 0 0 1-10.12-2.045 25.824 25.824 0 0 1-8.263-5.572 25.879 25.879 0 0 1-5.572-8.264 25.852 25.852 0 0 1-2.042-10.121 25.917 25.917 0 0 1 7.614-18.383 25.927 25.927 0 0 1 18.383-7.613 25.94 25.94 0 0 1 18.386 7.613 25.918 25.918 0 0 1 7.616 18.383 25.918 25.918 0 0 1-7.616 18.385 25.866 25.866 0 0 1-8.265 5.572 25.816 25.816 0 0 1-10.121 2.045Zm-3.523-33.496a.81.81 0 0 0-.58.24l-.495.496a.827.827 0 0 0 0 1.164l5.628 5.625-5.633 5.639a.83.83 0 0 0 0 1.166l.49.494c.152.152.366.24.585.24a.81.81 0 0 0 .58-.24l6.71-6.709a.835.835 0 0 0 0-1.17l-6.7-6.705a.815.815 0 0 0-.585-.24Z",
    fillRule: "evenodd"
  }));
};
var ImageLinkCard = function ImageLinkCard(props) {
  var title = props.title,
    url = props.url,
    image = props.image,
    className = props.className,
    titleColor = props.titleColor;
  var classes = [_ImageLinkCardModule["default"].ImageLinkCard, className];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.join(' '),
    "data-testid": "ImageLinkCard"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_LoadingImage["default"], {
    image: image,
    altText: title
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ImageLinkCardModule["default"].title
  }, /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      color: titleColor
    }
  }, title), /*#__PURE__*/_react["default"].createElement(Arrow, {
    fill: titleColor
  }))));
};
ImageLinkCard.defaultProps = {
  titleColor: 'white',
  title: 'untitled',
  image: '',
  url: '#',
  className: ''
};
var _default = ImageLinkCard;
exports["default"] = _default;